import { usePolicyPageData } from '#src/app/pages/legal/policy/pageContext';
import { getViewEventName } from '#src/app/pages/legal/policy/shared/utils';
import { useTrackView } from '#src/app/shared/hooks/tracking';

export function useTrackPageView(): void {
	const {
		data: { slug },
	} = usePolicyPageData();

	useTrackView(getViewEventName(slug));
}
